module.exports = __webpack_public_path__ + "static/media/CompanyKitchenWelcome.de4cafe6.png";